import React from "react";

export const Map = () => (
  <iframe
    title="google maps location"
    width="100%"
    height="100%"
    frameBorder="0"
    style={{ border: "0" }}
    src={`https://www.google.com/maps/embed/v1/place?key=${process.env.GATSBY_GOOGLE_MAPS_KEY}&q=37+Rosyth+Rd,+Glasgow+G5+0YD`}
    allowFullScreen
  />
);
